<template>
  <v-footer height="auto" color="#59595B">
    <v-container fluid grid-list-xl class="text-white georgia">
      <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
      <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
      <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
      <!-- ========================================================================================= -->
      <div v-responsive.lg.xl>
        <v-layout row wrap px-3 pt-md-4 pb-0>
          <v-flex xs12 sm12 md4 lg4>
            <!-- bloc 1 -->
            <v-card flat color="#59595B">
              <v-img>
                <a href="/" style="margin-left: 27%">
                  <img width="150" alt="logo assuraf blanc" src="../assets/img/assuraf_white.png" />
                </a>
              </v-img>

              <v-card-text style="margin-left: 23%">
                <ul class="list-group full-width subheading policeLato">
                  <!-- <li class="list-group-item px-0 py-1 mb-xs-0 pb-xs-0 d-inline-block">
                                        <span class="mr-0"><i class="material-icons" aria-hidden="true" data-nosnippet>&#xe0c8;</i></span>
                                        <span class="pl-3 text-xs-right justify-end">{{ $t('footer.adresse') }}</span>
                                    </li> -->
                  <!-- <li class="list-group-item px-0 py-1"><a href="https://maps.app.goo.gl/nqfzawpztGhFiYVW6" target="_blank"><i class="material-icons pr-3" style="font-size: 30px;" aria-hidden="true" data-nosnippet>&#xe0c8;</i> <span style="position: absolute;margin-top: 5px">{{ $t('footer.adresse') }}</span></a></li> -->
                  <!-- <li class="list-group-item px-0 py-1"><i class="material-icons pr-3" style="font-size: 30px" aria-hidden="true" data-nosnippet>&#xe0be;</i><a href="mailto:contact@assuraf.com"> <span style="position: absolute;margin-top: -10px">{{ $t('footer.mail') }}</span></a></li> -->
                  <!-- <li class="list-group-item px-0 py-1"><i class="material-icons pr-3" aria-hidden="true" data-nosnippet style="font-size: 30px;">&#xe0cd;</i> {{ $t('footer.telephone') }}</li> -->

                  <li class="list-group-item px-0 py-1">
                    <v-icon class="pr-3" style="font-size: 30px; color: #fff">place</v-icon>
                    <a href="https://maps.app.goo.gl/nqfzawpztGhFiYVW6" target="_blank">{{
                      $t('footer.adresse')
                    }}</a>
                  </li>

                  <li class="list-group-item px-0 py-1">
                    <v-icon class="pr-3" style="font-size: 30px; color: #fff">email</v-icon>
                    <a href="mailto:contact@assuraf.com">{{ $t('footer.mail') }}</a>
                  </li>

                  <li class="list-group-item px-0 py-1">
                    <i
                      class="material-icons pr-3"
                      style="font-size: 30px"
                      aria-hidden="true"
                      data-nosnippet
                      >&#xe0cd;</i
                    >
                    <a href="tel:+221761416464">{{ $t('footer.telephone') }}</a>
                  </li>
                  <li class="list-group-item px-0 py-1">
                    <i
                      class="material-icons pr-3"
                      style="font-size: 30px"
                      aria-hidden="true"
                      data-nosnippet
                      >&#xe0cd;</i
                    >
                    <a href="tel:+221762006464">+221 76 200 64 64</a>
                  </li>
                  <li class="list-group-item px-0 py-1">
                    <i
                      class="material-icons pr-3"
                      style="font-size: 30px"
                      aria-hidden="true"
                      data-nosnippet
                      >&#xe0cd;</i
                    >
                    <a href="tel:+221768006464">+221 76 800 64 64</a>
                  </li>
                  <li class="list-group-item px-0 py-1">
                    <a href="https://wa.me/221761416464?text=Hello%20Assur’Web" target="blank"
                      ><i class="fab fa-whatsapp fa-2x pr-3"></i> {{ $t('footer.whatsapp') }}</a
                    >
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-flex>
          <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
          <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
          <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
          <!-- ========================================================================================= -->
          <v-flex xs12 sm12 md4 lg4 pb-1 mb-1>
            <!-- bloc 2 DESKTOP -->
            <v-card flat color="#59595B" class="mt-3">
              <v-layout align-center>
                <v-flex class="ml-2" style="margin-top: 0px">
                  <p class="title-border title text-white policeLato font-weight-bold">
                    {{ $t('footer.souscription_title') }}
                  </p>
                  <ul
                    class="list-group full-width subheading policeLato"
                    style="display: flex; flex-direction: column"
                  >
                    <li class="font-weight-bold">{{ $t('home_page.particulier_label') }}</li>
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      ><a href="/devis/auto">{{ $t('footer.souscription_content_list[0]') }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/devis/habitation">{{
                        $t('footer.souscription_content_list[1]')
                      }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/devis/voyage">{{ $t('footer.souscription_content_list[2]') }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/devis/sante">{{ $t('footer.souscription_content_list[3]') }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/devis/vie">{{ $t('footer.souscription_content_list[4]') }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/plus">{{ $t('footer.souscription_content_list[5]') }}</a>
                    </li>

                    <li class="mt-3 font-weight-bold">Express</li>
                    <li class="list-group-item px-0 py-1 pa-0 py-1 d-inline-block">
                      <img
                        src="../assets/img/footer/moto.png"
                        width="18"
                        alt="Aywa"
                        class="parcours-icon"
                      />
                      <a href="/aywa">Aywa</a>
                    </li>
                    <li class="list-group-item px-0 py-1 pa-0 py-1 d-inline-block">
                      <img
                        src="../assets/img/footer/auto.png"
                        width="18"
                        alt="Dem"
                        class="parcours-icon"
                      />
                      <a href="/dem">Dem</a>
                    </li>
                    <li class="list-group-item px-0 py-1 pa-0 py-1 d-inline-block">
                      <img
                        src="../assets/img/footer/globe.png"
                        width="18"
                        alt="Tukki"
                        class="parcours-icon"
                      />
                      <a href="/tukki">Tukki</a>
                    </li>

                    <li class="mt-3 font-weight-bold">{{ $t('home_page.entreprise_label') }}</li>
                    <li class="list-group-item px-0 py-1 pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/flotte/entreprise">{{ $t('menu.Devis[7]') }}</a>
                    </li>
                    <li class="list-group-item px-0 py-1 pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/devis/mrp">Devis MRP</a>
                    </li>
                    <li class="list-group-item px-0 py-1 pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/devis/trc">Devis TRC</a>
                    </li>
                    <li class="list-group-item px-0 py-1 pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/rcscolaire">{{ $t('menu.Devis[8]') }}</a>
                    </li>
                  </ul>
                </v-flex>

                <v-flex class="ml-2" style="margin-top: -60px">
                  <p class="title-border title text-white policeLato font-weight-bold">
                    {{ $t('footer.assuraf_title') }}
                  </p>
                  <ul
                    class="list-group full-width subheading policeLato"
                    style="display: flex; flex-direction: column"
                  >
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/apropos/#notrehistoire">{{
                        $t('footer.assuraf_content_list[0]')
                      }}</a>
                    </li>

                    <li
                      class="list-group-item pa-0 py-1 d-inline-block"
                      @click="RedirectionEspaceAssure()"
                    >
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a slot="activator">{{ $t('footer.assuraf_content_list[1]') }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/info/legale">{{ $t('footer.assuraf_content_list[2]') }}</a>
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/condition/generale">{{ $t('footer.assuraf_content_list[3]') }}</a>
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/apropos/#faq">{{ $t('footer.assuraf_content_list[4]') }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://developer.assuraf.com/" target="_blank">{{
                        $t('footer.assuraf_content_list[5]')
                      }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://agent.assuraf.com/" target="_blank">Assur'Agent</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://assur.care" target="_blank">{{
                        $t('footer.assuraf_content_list[8]')
                      }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://assuraf.com/plateforme/demo" target="_blank">{{
                        $t('footer.assuraf_content_list[6]')
                      }}</a>
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/pro">Assuraf Pro Online</a>
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/lead">Assur'Lead</a>
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/cv">{{ $t('footer.assuraf_content_list[7]') }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block pb-5">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="javascript:void(0)" @click="goToSinistre()">{{
                        $t('menu.sinistre_label')
                      }}</a>
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 sm12 md4 lg4 pb-1 mb-1>
            <!-- bloc 3 DESKTOP -->
            <v-card flat color="#59595B" class="mt-3">
              <v-layout row align-center>
                <v-flex class="ml-5">
                  <p class="title-border title text-white policeLato font-weight-bold">
                    Présence sous-régionale
                  </p>
                  <ul
                    class="list-group full-width subheading policeLato"
                    style="display: flex; flex-direction: column"
                  >
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://faaci.assuraf.com" target="_blank"
                        >Côte d’Ivoire 🇨🇮 : Filhet-Allard Africa</a
                      >
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block pb-5">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://gcourtage.assuraf.com" target="_blank"
                        >Guinée 🇬🇳 : Générale de Courtage</a
                      >
                    </li>
                  </ul>
                </v-flex>

                <v-flex class="ml-5" style="margin-top: -6% !important">
                  <p class="title-border title text-white policeLato font-weight-bold">
                    {{ $t('footer.download_app_label') }}
                  </p>
                  <ul class="list-group full-width">
                    <li>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.afdecoding.assurafmobile"
                        target="_blank"
                      >
                        <img
                          src="../assets/img/logo_playStore.png"
                          width="120"
                          alt="assuraf_playstor"
                        />
                      </a>
                    </li>

                    <li class="mt-2">
                      <a
                        href="https://apps.apple.com/sn/app/assuraf/id1641569465?l=fr"
                        target="_blank"
                      >
                        <img
                          src="../assets/img/logo-appStore.png"
                          width="120"
                          alt="assuraf_appstor"
                        />
                      </a>
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>

        <!--boutons de partage des réseaux sociaux-->
        <v-layout row>
          <v-flex xs12 sm12 md4 lg4 justify-space-around>
            <v-layout justify-center>
              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://www.linkedin.com/company/assuraf/"
                aria-label="LinkedIn"
                @click="Gtm_click_follow('click_follow_linkedIn')"
                rel="noopener noreferrer"
                title="Suivez-nous sur LinkedIn"
              >
                <span class="fa-stack" aria-hidden="true">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-linkedin-in fa-inverse fa-stack-1x"></i>
                </span>
              </a>
              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://twitter.com/assuraf_tech"
                aria-label="Twitter"
                @click="Gtm_click_follow('click_follow_twitter')"
                rel="noopener noreferrer"
                title="Suivez-nous sur Twitter"
              >
                <span class="fa-stack">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-twitter fa-inverse fa-stack-1x"></i>
                </span>
              </a>
              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://www.facebook.com/assuraf/"
                aria-label="Facebook"
                rel="noopener noreferrer"
                title="Suivez-nous sur Facebook"
                @click="Gtm_click_follow('click_follow_facebook')"
              >
                <span class="fa-stack">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-facebook-f fa-inverse fa-stack-1x"></i>
                </span>
              </a>
              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://www.instagram.com/assur.af/"
                aria-label="Instagram"
                rel="noopener noreferrer"
                title="Suivez-nous sur Instagram"
                @click="Gtm_click_follow('click_follow_instagram')"
              >
                <span class="fa-stack">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-instagram fa-inverse fa-stack-1x"></i>
                </span>
              </a>
            </v-layout>

            <v-layout justify-center class="mt-3">
              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://www.youtube.com/channel/UCqAcE6_oY7sHHHpGZ_b00Kg/"
                aria-label="YouTube"
                rel="noopener noreferrer"
                title="Suivez-nous sur YouTube"
                @click="Gtm_click_follow('click_follow_youtube')"
              >
                <span class="fa-stack">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-youtube fa-inverse fa-stack-1x"></i>
                </span>
              </a>

              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://www.tiktok.com/@Assuraf"
                aria-label="TikTok"
                rel="noopener noreferrer"
                title="Suivez-nous sur TikTok"
                @click="Gtm_click_follow('click_follow_tiktok')"
              >
                <span class="fa-stack">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-tiktok fa-inverse fa-stack-1x"></i>
                </span>
              </a>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap px-3 pt-0 mb-3 align-center justify-center>
          <v-flex xs12 sm12 md4 lg4 class="text-center">
            <span class="text-white policeLato">
              &copy; Copyright {{ date }} —
              <strong style="color: #ffa409">assuraf</strong>
            </span>
          </v-flex>

          <v-flex xs12 sm12 md4 lg4 class="text-center">
            <span class="text-white policeLato"
              >{{ $t('footer.developper_title[0]') }}
              <img src="../assets/img/flag_emoji.png" width="20" alt="emoji_flag" />
              {{ $t('footer.developper_title[1]') }}</span
            >
          </v-flex>

          <v-flex xs12 sm12 md4 lg4 class="text-center" style="margin-top: -40px">
            <a
              href="https://www.sitelock.com/verify.php?site=assuraf.com"
              target="_blank"
              rel="noopener noreferrer"
              ><img
                class="img-responsive"
                alt="SiteLock"
                title="SiteLock"
                src="https://shield.sitelock.com/shield/assuraf.com"
            /></a>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>

      <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
      <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
      <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
      <!-- ========================================================================================= -->
      <div v-responsive.sm.xs>
        <v-layout row wrap px-3 pt-md-4 pb-0>
          <v-flex xs12 sm12 md4 lg4 ml-3>
            <!-- bloc 1 -->
            <v-card flat color="#59595B">
              <v-img>
                <a href="/">
                  <img class="mt-5" width="150" alt="logo" src="../assets/img/assuraf_white.png" />
                </a>
              </v-img>
              <!-- <a href="tel:+4733378901">+47 333 78 901</a> -->
              <v-card-text class="pl-0">
                <ul class="list-group full-width subheading policeLato">
                  <!-- <li class="list-group-item px-0 py-1"> <a href="https://maps.app.goo.gl/nqfzawpztGhFiYVW6" target="_blank"><i class="material-icons" aria-hidden="true" data-nosnippet>&#xe0c8;</i><span style="position: absolute;margin-top:5px">{{ $t('footer.adresse') }}</span></a></li>
                                    <li class="list-group-item px-0 py-1"><i class="material-icons" aria-hidden="true" data-nosnippet>&#xe0be;</i> <a href="mailto:contact@assuraf.com"> <span style="position: absolute;margin-top:-10px">{{ $t('footer.mail') }}</span></a></li> -->

                  <li class="list-group-item px-0 py-1">
                    <v-icon class="pr-3" style="font-size: 25px; color: #fff">place</v-icon>
                    <a href="https://maps.app.goo.gl/nqfzawpztGhFiYVW6" target="_blank">{{
                      $t('footer.adresse')
                    }}</a>
                  </li>

                  <li class="list-group-item px-0 py-1">
                    <v-icon class="pr-3" style="font-size: 25px; color: #fff">email</v-icon>
                    <a href="mailto:contact@assuraf.com">{{ $t('footer.mail') }}</a>
                  </li>

                  <li class="list-group-item px-0 py-1">
                    <i class="material-icons" aria-hidden="true" data-nosnippet>&#xe0cd;</i>
                    <a href="tel:+221761416464">{{ $t('footer.telephone') }}</a>
                  </li>
                  <li class="list-group-item px-0 py-1">
                    <i class="material-icons" aria-hidden="true" data-nosnippet>&#xe0cd;</i>
                    <a href="tel:+221762006464">+221 76 200 64 64</a>
                  </li>
                  <li class="list-group-item px-0 py-1">
                    <i class="material-icons" aria-hidden="true" data-nosnippet>&#xe0cd;</i>
                    <a href="tel:+221768006464">+221 76 800 64 64</a>
                  </li>
                  <li class="list-group-item px-0 py-1 pl-1">
                    <a
                      href="https://wa.me/221761416464?text=Hello%20Assur’Web"
                      target="_blank"
                      class="pl-1"
                      ><i class="fab fa-whatsapp" style="font-size: 20px"></i
                      >{{ $t('footer.whatsapp') }}</a
                    >
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-flex>
          <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
          <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
          <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
          <!-- ========================================================================================= -->
          <v-flex xs12 sm12 pb-1 mb-1>
            <!-- bloc parcours simplifiés MOBILE -->
            <v-card flat color="#59595B">
              <v-layout column>
                <v-flex class="ml-3">
                  <p class="title-border title text-white policeLato">Souscription Express</p>
                  <ul
                    class="list-group full-width subheading policeLato"
                    style="display: flex; flex-direction: column"
                  >
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <img
                        src="../assets/img/footer/moto.png"
                        width="18"
                        alt="Aywa"
                        class="parcours-icon"
                      />
                      <a href="/aywa">Aywa</a>
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <img
                        src="../assets/img/footer/auto.png"
                        width="18"
                        alt="Dem"
                        class="parcours-icon"
                      />
                      <a href="/dem">Dem</a>
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <img
                        src="../assets/img/footer/globe.png"
                        width="18"
                        alt="Tukki"
                        class="parcours-icon"
                      />
                      <a href="/tukki">Tukki</a>
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 sm12 pb-1 mb-1>
            <!-- bloc 2 MOBILE -->
            <v-card flat color="#59595B">
              <v-layout column>
                <v-flex class="ml-3">
                  <p class="title-border title text-white policeLato">
                    {{ $t('footer.assuraf_title') }}
                  </p>
                  <ul
                    class="list-group full-width subheading policeLato"
                    style="display: flex; flex-direction: column"
                  >
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/apropos/#notrehistoire">{{
                        $t('footer.assuraf_content_list[0]')
                      }}</a>
                    </li>

                    <li
                      class="list-group-item pa-0 py-1 d-inline-block"
                      @click="RedirectionEspaceAssure()"
                    >
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a slot="activator">{{ $t('footer.assuraf_content_list[1]') }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/info/legale">{{ $t('footer.assuraf_content_list[2]') }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/condition/generale">{{ $t('footer.assuraf_content_list[3]') }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/apropos/#faq">{{ $t('footer.assuraf_content_list[4]') }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://developer.assuraf.com/" target="_blank">{{
                        $t('footer.assuraf_content_list[5]')
                      }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://agent.assuraf.com/" target="_blank">Assur'Agent</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://assur.care" target="_blank">{{
                        $t('footer.assuraf_content_list[8]')
                      }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://assuraf.com/plateforme/demo" target="_blank">{{
                        $t('footer.assuraf_content_list[6]')
                      }}</a>
                    </li>

                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/pro">Assuraf Pro Online</a>
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/lead">Assur'Lead</a>
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="/cv">{{ $t('footer.assuraf_content_list[7]') }}</a>
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block pb-5">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="javascript:void(0)" @click="goToSinistre()">{{
                        $t('menu.sinistre_label')
                      }}</a>
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 sm12 pb-1 mb-1 class="mt-4">
            <!-- bloc 2 MOBILE -->
            <v-card flat color="#59595B">
              <v-layout column>
                <v-flex class="ml-3">
                  <p class="title-border title text-white policeLato">Présence sous-régionale</p>
                  <ul
                    class="list-group full-width subheading policeLato"
                    style="display: flex; flex-direction: column"
                  >
                    <li class="list-group-item pa-0 py-1 d-inline-block">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://faaci.assuraf.com/" target="_blank"
                        >Côte d’Ivoire 🇨🇮 : Filhet-Allard Africa</a
                      >
                    </li>
                    <li class="list-group-item pa-0 py-1 d-inline-block pb-5">
                      <i class="tiny-icon material-icons mx-0" aria-hidden="true" data-nosnippet
                        >&#xe5cc;</i
                      >
                      <a href="https://gcourtage.assuraf.com" target="_blank"
                        >Guinée 🇬🇳 : Générale de Courtage</a
                      >
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 sm12 pb-1 mb-1 class="mt-3">
            <!--boutons de téléchargement appli assuraf-->

            <v-card flat color="#59595B">
              <v-layout column>
                <v-flex class="ml-3">
                  <p class="title-border title text-white policeLato">
                    {{ $t('footer.download_app_label') }}
                  </p>
                  <ul class="list-group full-width subheading policeLato" style="display: inline">
                    <li class="list-group-item d-inline-block">
                      <a
                        href="https://play.google.com/store/apps/details?id=com.afdecoding.assurafmobile"
                        target="_blank"
                      >
                        <img
                          src="../assets/img/logo_playStore.png"
                          width="120"
                          alt="assuraf_playstor"
                        />
                      </a>

                      <a
                        href="https://apps.apple.com/sn/app/assuraf/id1641569465?l=fr"
                        target="_blank"
                      >
                        <img
                          src="../assets/img/logo-appStore.png"
                          width="120"
                          alt="assuraf_playstor"
                        />
                      </a>
                    </li>

                    <!-- <li class="ml-3 list-group-item d-inline-block">
                                            <a href="https://apps.apple.com/sn/app/assuraf/id1641569465?l=fr" target="_blank">
                                                <img src="../assets/img/logo-appStore.png"  width="120" alt="assuraf_playstor">
                                            </a>
                                        </li> -->
                  </ul>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>

        <!--boutons de partage des réseaux sociaux-->
        <v-layout class="mt-3" row>
          <v-flex xs12 sm12 md4 lg4 justify-space-around>
            <v-layout justify-center>
              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://www.linkedin.com/company/assuraf/"
                aria-label="LinkedIn"
                rel="noopener noreferrer"
                title="Suivez-nous sur LinkedIn"
                @click="Gtm_click_follow('click_follow_linkedIn')"
              >
                <span class="fa-stack">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-linkedin-in fa-inverse fa-stack-1x"></i>
                </span>
              </a>
              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://twitter.com/assuraf_tech"
                aria-label="Twitter"
                rel="noopener noreferrer"
                title="Suivez-nous sur Twitter"
                @click="Gtm_click_follow('click_follow_twitter')"
              >
                <span class="fa-stack">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-twitter fa-inverse fa-stack-1x"></i>
                </span>
              </a>
              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://www.facebook.com/assuraf/"
                aria-label="Facebook"
                rel="noopener noreferrer"
                title="Suivez-nous sur Facebook"
                @click="Gtm_click_follow('click_follow_facebook')"
              >
                <span class="fa-stack">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-facebook-f fa-inverse fa-stack-1x"></i>
                </span>
              </a>
              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://www.instagram.com/assur.af/"
                aria-label="Instagram"
                rel="noopener noreferrer"
                title="Suivez-nous sur Instagram"
                @click="Gtm_click_follow('click_follow_instagram')"
              >
                <span class="fa-stack">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-instagram fa-inverse fa-stack-1x"></i>
                </span>
              </a>
              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://www.youtube.com/channel/UCqAcE6_oY7sHHHpGZ_b00Kg/"
                aria-label="YouTube"
                rel="noopener noreferrer"
                title="Suivez-nous sur YouTube"
                @click="Gtm_click_follow('click_follow_youtube')"
              >
                <span class="fa-stack">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-youtube fa-inverse fa-stack-1x"></i>
                </span>
              </a>

              <a
                target="_blank"
                class="social-btn pl-3"
                href="https://www.tiktok.com/@Assuraf"
                aria-label="TikTok"
                rel="noopener noreferrer"
                title="Suivez-nous sur TikTok"
                @click="Gtm_click_follow('click_follow_tiktok')"
              >
                <span class="fa-stack">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fab fa-tiktok fa-inverse fa-stack-1x"></i>
                </span>
              </a>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap px-3 pt-0 mb-3 align-center justify-center>
          <v-flex xs12 sm12 md4 lg4 class="text-center">
            <span class="text-white policeLato">
              &copy; Copyright {{ date }} —
              <strong style="color: #ffa409">assuraf</strong>
            </span>
          </v-flex>

          <v-flex
            xs12
            sm12
            md4
            lg4
            class="text-center ml-3"
            style="margin-top: -25px; margin-bottom: -25px"
          >
            <span class="text-white policeLato"
              >{{ $t('footer.developper_title[0]') }}
              <img src="../assets/img/flag_emoji.png" width="20" alt="emoji_flag" />
              {{ $t('footer.developper_title[1]') }}</span
            >
          </v-flex>

          <v-flex xs12 sm12 md4 lg4 class="text-center ml-3 pt-5">
            <a
              href="https://www.sitelock.com/verify.php?site=assuraf.com"
              target="_blank"
              rel="noopener noreferrer"
              ><img
                class="img-responsive"
                alt="SiteLock"
                title="SiteLock"
                src="https://shield.sitelock.com/shield/assuraf.com"
            /></a>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>

      <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>
    </v-container>

    <!-- Partie du cookies avec le plugin cookie-law partie DESKTOP-->
    <!-- <cookie-law class="justify-center row cookiestyle" position="top" v-if="isDesktop()" style="margin-top: 30%">
            <div class="justify-content-center row" slot-scope="props">
                <span class="justify-content-center row mt-2 mb-2">
                    <v-icon style="font-size: 40px;color: #C55A10">&#xeaac;</v-icon>
                </span>
                <div class="justify-content-lg-end">
                    <v-icon @click="props.accept" style="color: #999999;float: right;position: absolute;margin-left:40%">&#xe5cd;</v-icon>
                </div>

              
                <p class=" justify-content-center font-weight-bold ml-5 mr-5 policeLato" style="font-size: 15px">
                    {{ $t('footer.cookie_content[0]') }} <a id="LienCGU" style="color:#ffa409" href="/info/legale">{{ $t('footer.cookie_content[1]') }}.</a>                    
                </p>
                <p class="justify-content-center row" style="margin-bottom:-10px">

                    <button flat class="watch_video mt-2 mb-3" @click="props.accept">
                        <span class="watch_video">J'accepte</span>
                    </button>
                </p>
            </div>
        </cookie-law> -->

    <!-- Partie du cookies avec le plugin cookie-law partie MOBILE-->
    <!-- <cookie-law transitionName="slideFromBottom" class="cookiestyle_mobile" position="bottom" style="margin-bottom: 5%" v-if="isMobile()">
            <div class="justify-content-center row" slot-scope="props">
                <span class="justify-content-center row">
                    <v-icon style="font-size: 40px;color: #C55A10">&#xeaac;</v-icon>
                </span>
                <div class="justify-content-lg-end">
                    <v-icon @click="props.accept" style="color: #999999;float: right;position: absolute;margin-left:40%">&#xe5cd;</v-icon>
                </div>
                <p class="font-weight-light policeLato">
                    {{ $t('footer.cookie_content[0]') }} <a id="LienCGU" style="color:#ffa409" href="/info/legale">{{ $t('footer.cookie_content[1]') }}</a>
                </p>
                <p class="justify-content-center row">
                    <button flat class="watch_video_mobile" @click="props.accept">
                        <span class="watch_video_mobile">J'accepte</span>
                    </button>
                </p>
            </div>
        </cookie-law> -->
    <CookiePopup v-if="showCookiePopup" @accepted="handleCookieAccept" @later="handleCookieLater" />
  </v-footer>
</template>

<script>
import dayjs from 'dayjs';
import CookieLaw from 'vue-cookie-law';
import PushInDataLayer from '../services/TagManager';
import CookiePopup from '../components/auth/CookiePopup.vue';

export default {
  name: 'footer',
  components: {
    LoginForm: () => import(/* webpackPrefetch: true */ './auth/Login'),
    CookieLaw,
    CookiePopup
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      email: '',
      emailRules: [
        (v) => !!v || 'Saisissez votre mail',
        (v) => /.+@.+/.test(v) || "l'adresse mail doit être valide"
      ],
      UserEmail: null,
      LoginDialog: false,
      showLoginForm: false,
      showCookiePopup: false,
      ToastTabSucess: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 6000,
        fitToScreen: true,
        type: 'success',
        className: 'custom-success-class'
      }, // Customized options for success toast
      ToastTabError: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 6000,
        fitToScreen: true,
        type: 'error'
      }, //

      ToastTabInfo: {
        theme: 'toasted-warning',
        position: 'top-center',
        duration: 6000,
        fitToScreen: true,
        type: 'error'
      }
    };
  },
  methods: {
    goToSinistre() {
      if (this.$store.state.isUserLoggedIn) {
        this.$router.go(this.$router.push('/sinistre'));
      } else {
        this.showLoginForm = true;
      }
    },
    handleCookieAccept() {
      this.showCookiePopup = false;

      // Intégration avec votre système GTM existant
      const GtmVal = {
        event: 'cookie_consent_accepted'
      };
      PushInDataLayer(GtmVal);
    },

    handleCookieLater() {
      this.showCookiePopup = false;

      const GtmVal = {
        event: 'cookie_consent_later'
      };
      PushInDataLayer(GtmVal);
    },

    checkCookieConsent() {
      const consent = localStorage.getItem('cookieConsent');
      const laterTime = localStorage.getItem('cookieLaterTime');
      const currentTime = new Date().getTime();

      if (consent === 'accepted') {
        this.showCookiePopup = false;
      } else if (laterTime && currentTime < parseInt(laterTime)) {
        this.showCookiePopup = false;
      } else {
        this.showCookiePopup = true;
      }
    },
    Gtm_click_follow(param) {
      const GtmVal = {
        event: param
      };
      PushInDataLayer(GtmVal);
    },

    isMobile: function () {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },

    isDesktop: function () {
      if (screen.width > 760) {
        return true;
      } else {
        return false;
      }
    },

    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },

    RedirectionEspaceAssure() {
      if (this.$store.state.isUserLoggedIn) {
        this.$router.push('/dashboard');
      } else {
        this.showLoginForm = true;
      }
    }
  },
  mounted() {
    let dateTime = dayjs(this.date).format('YYYY');
    this.date = dateTime;
    // Vérifier le consentement des cookies
    this.checkCookieConsent();
  }
};
</script>

<style scoped lang="less">
@import '../assets/less/config';

.tiny-icon {
  font-size: 20px;
}

.cookiestyle {
  font-size: 13px;
  height: auto;
  background-color: #fff;
  width: 650px;
  border-radius: 30px;
  box-shadow: 0px 0px 10px #555555;
  position: fixed;
  top: 28%;
  left: 51%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.cookiestyle_mobile {
  font-size: 13px;
  height: auto;
  background-color: #fff;
  width: 90%;
  border-radius: 30px;
  box-shadow: 0px 0px 10px #555555;
  margin-top: 30%;
  margin-left: 20px;
}

#LienCGU {
  margin-bottom: -5px;
}

.title-border {
  border-left: 5px solid #ffa409;
  padding-left: 0.6em;
  line-height: 0.9em;
}

a.social-btn {
  color: inherit;
  text-decoration: none;
}

.vuefooter {
  color: #ffffff;
  margin-top: -10px;
  scroll-behavior: smooth;
}

ul {
  list-style: none;

  li {
    color: #ffffff;
    display: flex;
    justify-content: left;

    i {
      color: #ffffff;
    }

    a {
      color: #ffffff;
      text-decoration: none;
    }
  }
}

.first-row {
  .logoFooter {
    margin-left: -5%;
  }

  ul {
    max-width: 120% !important;
    margin-left: -15%;

    li {
      max-width: 100% !important;

      i {
        display: block;
        float: left;
      }
    }
  }
}

.menufooter {
  li {
    display: inline-block;
  }
}

.reseausociaux {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 5%;

  img {
    width: 30px;
    height: 30px;
  }
}

.appimage {
  height: 40px;
  width: 150px;
}

.parcours-icon {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-right: 6px;
}

/*========Responsive css  @media screen and (max-width: 601px)======*/
@media screen and (max-width: 425px) {
  .layout .first-row {
    max-width: 100%;

    ul {
      font-size: 15px;
      margin-left: 0px;
      margin-top: 50px;
      margin-bottom: -20px;

      li {
        margin-left: -20%;
        margin-top: -47px;
      }
    }

    img {
      width: 100%;
    }

    a {
      margin-top: -30px;
    }
  }

  .layout .second-row {
    max-width: 100%;
    margin-top: 35px;
    margin-left: 9%;
    padding-top: 0px !important;

    ul {
      margin-left: -58%;
    }

    h3 {
      margin: 0px !important;
      margin-left: -30% !important;
    }
  }

  .appimage {
    margin-top: 45px;
    margin-left: -19px !important;
  }

  .layout .third-row {
    margin-top: 75% !important;
    margin-left: -46%;
    padding-top: 0% !important;
    max-width: 100% !important;

    h3 {
      margin-left: -31%;
      margin-top: 3% !important;
    }

    ul {
      margin-left: -63%;
      margin-top: -38% !important;
    }
  }

  .layout .last-row {
    /* display: block; */
    margin-top: 74% !important;
    margin-left: -93%;
    padding-top: 0% !important;
    max-width: 100% !important;

    form {
      margin-left: -46%;
      margin-top: -37%;
    }

    h3 {
      margin-left: -45%;
      margin-top: 3% !important;
    }
  }

  .reseausociaux {
    margin-left: -150px;
  }
}

/*========================Responsive css for phone screen 375px*/
@media screen and (max-width: 375px) {
  .layout .first-row {
    max-width: 100%;

    ul {
      font-size: 15px;
      margin-left: 0px;

      li {
        margin-left: -20%;
      }
    }

    img {
      width: 100%;
    }
  }

  .layout .second-row {
    max-width: 100%;
    margin-top: 35% !important;
    margin-left: 0%;
    padding-top: 0px !important;

    ul {
      margin-left: -58%;
    }

    h3 {
      margin: 0px !important;
      margin-left: -30% !important;
    }
  }

  .appimage {
    margin-top: 45px;
    width: 135px;
  }

  .layout .third-row {
    margin-top: 82% !important;
    margin-left: -52%;
    padding-top: 0% !important;
    max-width: 100% !important;

    h3 {
      margin-left: -31%;
      margin-top: 3% !important;
    }

    ul {
      margin-left: -63%;
      margin-top: -38% !important;
    }
  }

  .layout .last-row {
    /* display: block; */
    margin-top: 82% !important;
    margin-left: -96%;
    padding-top: 0% !important;
    max-width: 100% !important;

    form {
      margin-left: -46%;
      margin-top: -37%;
    }

    h3 {
      margin-left: -45%;
      margin-top: 3% !important;
    }
  }
}

/*========================Responsive css for phone screen 320px*/
@media screen and (max-width: 320px) {
  .layout .first-row {
    max-width: 100%;

    ul {
      font-size: 11px;
      margin-left: 0px;
      max-width: 100%;
      margin-top: 13% !important;

      li {
        margin-left: -20%;

        i {
          display: none;
        }
      }
    }

    img {
      width: 100%;
    }
  }

  .layout .second-row {
    max-width: 100%;
    margin-top: 30px;
    margin-left: 0%;
    padding-top: 0px !important;

    ul {
      margin-left: -58%;
      font-size: 11px;
    }

    h3 {
      margin: 0px !important;
      margin-left: -30% !important;
    }
  }

  .appimage {
    margin-top: 45px;
    width: 105px;
    height: 30px;
  }

  .layout .third-row {
    margin-top: 74% !important;
    margin-left: -50%;
    padding-top: 0% !important;
    max-width: 100% !important;

    h3 {
      margin-left: -31%;
      margin-top: 3% !important;
    }

    ul {
      margin-left: -63%;
      margin-top: -38% !important;
    }
  }

  .layout .last-row {
    /* display: block; */
    margin-top: 74% !important;
    margin-left: -106%;
    padding-top: 0% !important;
    max-width: 100% !important;

    form {
      margin-left: -46%;
      margin-top: -37%;
    }

    h3 {
      margin-left: -45%;
      margin-top: 3% !important;
    }
  }

  .reseausociaux {
    margin-left: 55%;

    li {
      margin-left: 1px;
    }
  }

  .menufooter {
    text-align: left;
    margin-left: 15%;
  }
}

.scrolltop-wrap {
  float: right;
  size: 3rem;
  /*offsetBottom: 2rem;
        offsetHorizontal: 2rem;
        scrollToRevealDistance: 12rem;*/
  box-sizing: border-box;
  bottom: 0;
  pointer-events: none;
  backface-visibility: hidden;
}

.scrolltop-bg {
  fill: orange;
}

#scrolltop-arrow {
  fill: white;
  transform: scale(0.66);
  transform-origin: center;
}

a:hover {
  #scrolltop-bg {
    fill: orange;
  }

  #scrolltop-arrow {
    fill: white;
  }
}

a:active {
  #scrolltop-bg {
    fill: orange;
  }
}

a {
  backface-visibility: hidden;
  display: inline-block;
  text-decoration: none;
  user-select: none;
  pointer-events: all;
  outline: none;
  overflow: hidden;
}

svg {
  display: block;
  border-radius: 50%;
  width: 100%;
  height: 100%;

  path {
    transition: all 0.1s;
  }
}

html {
  scroll-behavior: smooth;
}

#button {
  display: inline-block;
  background-color: #ff9800;
  width: 50px;
  height: 50px;
  text-align: center;
  border-radius: 4px;
  position: fixed;
  bottom: 30px;
  right: 30px;
  transition:
    background-color 0.3s,
    opacity 0.5s,
    visibility 0.5s;
  opacity: 0;
  visibility: hidden;
  z-index: 1000;
}

#button::after {
  content: '\f077';
  font-family: FontAwesome;
  font-weight: normal;
  font-style: normal;
  font-size: 2em;
  line-height: 50px;
  color: #fff;
}

#button:hover {
  cursor: pointer;
  background-color: #333;
}

#button:active {
  background-color: #555;
}

#button.show {
  opacity: 1;
  visibility: visible;
}

.georgia {
  font-family: Georgia;
}

.logo-paiement {
  background: #ffffff;
}
.titlePolice {
  font-family: Merriweather, Georgia, serif;
  font-weight: 300;
  //color: rgb(74, 74, 74);
}

.policeLato {
  font-family: Lato, 'Helvetica Neue', Arial, sans-serif;
}

.watch_video span {
  width: 200px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  text-transform: none;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  z-index: 1;
  cursor: pointer;
  border: 2px solid #ffa409;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.watch_video_mobile span {
  width: 150px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  text-transform: none;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  z-index: 1;
  cursor: pointer;
  border: 2px solid #ffa409;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}
</style>
